// BookingTable.jsx
import { Avatar, Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Grid, Grid2, IconButton, InputAdornment, ListItemIcon, ListItemText, Menu, MenuItem, Paper, Select, Snackbar, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TableSortLabel, Typography } from '@mui/material';
import threeDots from '../../assets/images/threeDots.svg';
import React, { useState,useEffect } from 'react';
import BlockImg from '../../assets/images/blockImg.svg';
import deleteImg from '../../assets/images/deleteImg.svg';
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import {makePostRequestToUrl} from '../commonFunc.jsx';
import CloseIcon from '@mui/icons-material/Close';
import config from '../../config/config.js';
import blueCarIcon from '../../assets/icons/blueCar.svg';
import { Label } from 'flowbite-react';
import PersonIcon from '@mui/icons-material/Person';
import AccessTimeFilledIcon from '@mui/icons-material/AccessTimeFilled';
import altProfile from '../../assets/images/altProfile.png';
import { Rowing } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';
import bagIcon from '../../assets/icons/Bag.svg';
import pickupIcon from '../../assets/icons/PickupIcon.svg';
import dropIcon from '../../assets/icons/DropIcon.svg';
import blackSeatIcon from '../../assets/icons/blackSeat.svg';
import { makeGetRequestToUrl } from '../commonFunc.jsx';
import greenTic from '../../assets/icons/greenTic.svg';
var constants = require('../../constant.js');

const BookingTable = ({ rows, onEditBooking, onFetchData, driversData, vehicleMakeData }) => {
  const operationsUrl = config.operationsUrl;
  const serverUrl = config.serverUrl;
  const cities = JSON.parse(localStorage.getItem('cities'));

  const [cityFilter, setCityFilter] = useState(cities[0].city_id);

  const [menuAnchorEl, setMenuAnchorEl] = useState(null);
  const [selectedRow, setSelectedRow] = useState(null);
  const [order, setOrder] = useState('desc');
  const [orderBy, setOrderBy] = useState('pickup_time');
  const [message, setMessage] = useState('');
  const [snackbar, showSnackbar] = useState(false);
  const [open, setOpen] = useState(false);
  const [openAssignModal, setOpenAssignModal] = useState(false);
  const [assignDriver, setAssignDriver] = useState({driver_id: '', vehicle_make_id: ''});
  const [editVehicleMakeId, setEditVehicleMakeId] = useState('');
  // const [bookingId, setBookingId] = useState('');
  const [openCancelConfirmModal, setOpenCancelConfirmModal] = useState(false);
  const [bookingToCancel, setBookingToCancel] = useState(null); // Though selectedRow is used by handleCancelBooking, this is for dialog context
  const [openDeleteConfirmModal, setOpenDeleteConfirmModal] = useState(false);
  const [bookingToDelete, setBookingToDelete] = useState(null); // Though selectedRow is used by handleCancelBooking, this is for dialog context
  const [isSaving, setIsSaving] = useState(false);
  const [tokenExpired, setTokenExpired] = useState(false);
  const [updatingStatusFor, setUpdatingStatusFor] = useState(null);
  const [openViewDetails, setOpenViewDetails] = useState(false);
  const [openDetails, setOpenDetails] = useState(false);
  const [openReassign, setOpenReassign] = useState(false);
  const [bookingtomarkNoShow, setBookingtomarkNoShow] = useState(null);
  const [openMarkNoShowConfirmModal, setOpenMarkNoShowConfirmModal] = useState(false);
  const [driverData, setDriverData] = useState([]);
  const [errorMessage, setErrorMessage] = useState('');
  const [vehiclesMakeData, setVehiclesMakeData] = useState([]);
  const [openUnassign, setOpenUnassign] = useState(false);
  const [unassignDriver, setUnassignDriver] = useState(null);

  const navigate = useNavigate();
  const ischange_point_to_comma = localStorage.getItem('change_point_to_comma');
  const client_id = localStorage.getItem('clientId');

  const parseNum = val => {
    if (val === undefined || val === null || val === '') return 0;
    let normalized = String(val).replace(/\s/g, '').replace(/,/g, '.').replace(/[^0-9.-]/g, '');
    const parts = normalized.split('.');
    if (parts.length > 2) {
        normalized = parts.slice(0, -1).join('') + '.' + parts[parts.length - 1];
    }
    const num = Number(normalized);
    return isNaN(num) ? 0 : num;
};  

const utcOffset = parseInt(localStorage.getItem('utc_offset') || '330', 10);
const timeZoneFormat = localStorage.getItem('time_zone_format') || '12';

const formatNumberWithComma = (num) => {
  if (num === null || num === undefined) return '';
  const strNum = String(num);
  return strNum.includes('.') ? strNum.replace('.', ',') : strNum;
};
const formatNumberWithdecimal = (num) => {
  if (num === null || num === undefined) return '';
  const strNum = String(num);
  return strNum.includes(',') ? strNum.replace(',', '.') : strNum;
};
    
  // Mapping of headers to their data fields
  const headerToField = {
    'Booking ID': 'booking_id',
    'Date & Time': 'pickup_time',
    'User Email': 'user_email',
    'Booking Mode': 'source',
    'Source ID': 'source_id',
    'Flight Number': 'flight_number',
    'Pickup Address': 'pickup_address',
    'Drop Address': 'drop_address',
    'Vehicle Type': 'vehicle_type',
    'Luggage Count': 'luggage_count',
    'Number of Seats': 'ticket_count',
    'Payment Status': 'payment_status',
    'Payment Mode': 'payment_mode',
    'Distance (in km)': 'distance',
    'Duration (in min)': 'duration',
    'Fare': 'fare',
    'Partner Price': 'partner_fare',
    'Extras': 'extra_fare',
    'Status': 'booking_status'
  };

  const handleRequestSort = (field) => {
    const isAsc = orderBy === field && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(field);
  };

  const sortedRows = React.useMemo(() => {
    const comparator = (a, b) => {
      let aValue = a[orderBy];
      let bValue = b[orderBy];

      // Handle numeric values
      if (orderBy === 'fare' || orderBy === 'ticket_count') {
        aValue = Number(aValue) || 0;
        bValue = Number(bValue) || 0;
      }

      if (bValue < aValue) return order === 'asc' ? 1 : -1;
      if (bValue > aValue) return order === 'asc' ? -1 : 1;
      return 0;
    };

    return [...rows].sort(comparator);
  }, [rows, order, orderBy]);

  const handleMenuOpen = (event, row) => {
    setMenuAnchorEl(event.currentTarget);
    setSelectedRow(row);
  };

  const handleMenuClose = () => {
    setMenuAnchorEl(null);
  };

  const handleBookingStatus = async (row, action) => {
    setUpdatingStatusFor(row.booking_id);
    const token = localStorage.getItem('token');
    const payload = {
      token: token,
      booking_id: row.booking_id,
      booking_status: action == 'accept' ? 2 : action == 'reject' ? 3 : '-1',
    };
    try {
      const url = operationsUrl + '/airport/create_and_update_bookings';
      const response = await makePostRequestToUrl(url, payload, null, 20000);
      if (response.flag === 200) {
        setMessage(response.message)
        showSnackbar(true);
        setOpen(false);
        if (onFetchData) {
          onFetchData();
        }
      }
      else if(response.flag==102){
        localStorage.removeItem('token');
        // setErrorMessage('Your session has expired. Please log in again.');
        setTokenExpired(true);
        setTimeout(() => {
            navigate('/signup');
        }, 2000);
      } else {
        setMessage(response.message)
        showSnackbar(true);
      }
    } catch (error) {
      console.error('Error', error);
      setMessage(error.message || 'An error occurred'); 
    } finally {
      setUpdatingStatusFor(null);
    }
  };

  const handleSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') {
        return; 
    }
    showSnackbar(false); 
  };


  const handleOpenEdit = () => {
    if (onEditBooking) {
      onEditBooking(selectedRow);
    }
    handleMenuClose();
  };

  const handleOpenAssignModal = (row) => {
    setOpenAssignModal(true);
    setSelectedRow(row);
    setAssignDriver({
      driver_id: '',
      vehicle_make_id: '',
    });
    setEditVehicleMakeId('');
  };
  const handleClose = () => {
    setOpenAssignModal(false);
    setSelectedRow(null);
  }

  const allowedFields = constants.BookingFieldToShow[client_id] || constants.BookingFieldToShow[1];

  const allHeaders = [
    'Booking ID',
    'Booking Mode',
    'Source ID',
    'User',
    'Driver',
    'User Email',
    'Date & Time',
    'Pickup Address',
    'Drop Address',
    'Stops',
    'Flight Number',
    'Vehicle Number',
    'Luggage Count',
    'Number of Seats',
    'Distance (in km)',
    'Duration (in min)',
    'Fare',
    'Tax',
    'Partner Price',
    'Extras',
    'Total Fare',
    'Payment Mode',
    'Payment Status',
    'Status',
    'Parent Booking ID', 
    'Journey Code',
    // 'Action'
    // ...(onEditBooking !== undefined ? ['Action'] : []),
  ];
  if(vehicleMakeData === undefined){
    allHeaders.push('Consent Form URL');
  }
  allHeaders.push('Action');

  const visibleHeaders = allowedFields && allowedFields.length > 0
    ? allHeaders.filter(header => allowedFields.includes(header) || header === 'Action')
    : allHeaders;


  const handleSubmit = async() => {
    const token = localStorage.getItem('token');
    if(!assignDriver.driver_id || !assignDriver.vehicle_make_id){
      setMessage("Please select driver and vehicle make");
      showSnackbar(true);
      return;
    }
    const payload = {
      token: token,
      booking_id: selectedRow.booking_id,
      driver_id: assignDriver.driver_id,
      vehicle_make_id: assignDriver.vehicle_make_id
    };
    setIsSaving(true);
    try {
      const url = operationsUrl + '/airport/assign_booking';
      const response = await makePostRequestToUrl(url, payload, null, 20000);
      
      if (response.flag === 200) {
        setMessage(response.message || 'Driver assigned successfully');
        showSnackbar(true);
        setOpenAssignModal(false);
        setOpenReassign(false);
        setAssignDriver({driver_id: '', vehicle_make_id: ''});
        setEditVehicleMakeId('');
        setSelectedRow(null);
        
        if (onFetchData) {
          onFetchData(); // Refresh the data
        }
      } else {
        setMessage(response.message || 'Failed to assign driver');
        showSnackbar(true);
      }
      handleMenuClose();
    } catch (error) {
      console.error('Error', error);
      setMessage(error.message || 'An error occurred'); 
    } finally {
      setIsSaving(false);
      showSnackbar(true);
    }
  }

  const openConfirmDialog = (action, rowData) => {
    handleMenuClose();
    if(action=='view') handleOpenDetails(true);
    if(action=='cancel') {
        setBookingToCancel(rowData || selectedRow); // Use rowData if passed, else fallback to selectedRow
        setOpenCancelConfirmModal(true);
        handleMenuClose(); // Close the three-dots menu
    }
    if(action == 'reassign') {
        setOpenReassign(true);

    }
    if(action == 'unassign') {
      setUnassignDriver(rowData || selectedRow);
      setOpenUnassign(true);

    }
    if(action == 'marknoshow'){
        setBookingtomarkNoShow(rowData || selectedRow);
        setOpenMarkNoShowConfirmModal(true);
        handleMenuClose();
    }
    if(action == 'delete'){
        setBookingToDelete(rowData || selectedRow);
        setOpenDeleteConfirmModal(true);
        handleMenuClose();
    }
    // setSelectedRow(selectedRow);
};

const handleCloseassignModal = () => {
  setOpenReassign(false);
  setSelectedRow(null);
  setAssignDriver({ driver_id: '', vehicle_make_id: '' });
  setEditVehicleMakeId('');
  };

  const handleMarkNoShowBooking = async() => {
          const token = localStorage.getItem('token');
          const payload = {
              token : token,
              booking_id: selectedRow.booking_id,
              booking_status: 11 
          }
          try {
                const url = operationsUrl + '/airport/create_and_update_bookings';
                const response = await makePostRequestToUrl(url, payload, null, 20000);
                if (response.flag === 200) {
                  setMessage(response.message)
                  showSnackbar(true);
                  // setOpen(false);
                  if (onFetchData) {
                    onFetchData(); // Refresh the data
                  }
                }
                else if(response.flag==102){
                  localStorage.removeItem('token');
                  // setErrorMessage('Your session has expired. Please log in again.');
                  setTokenExpired(true);
                  setTimeout(() => {
                      navigate('/signup');
                  }, 2000);
                } else {
                  setMessage(response.message)
                  showSnackbar(true);
                }
              } catch (error) {
                console.error('Error', error);
                setMessage(error.message || 'An error occurred'); 
              } finally {
              //   setUpdatingStatusFor(null);
              }
      }

      const fetchDriversData = async() => {
        try {
            const token = localStorage.getItem('token');
            const url = serverUrl + '/airport/fetch_drivers';
            const timestamp = new Date().getTime();
            const body = {
                token: token,
                timestamp: timestamp
            };
            const response =  await makeGetRequestToUrl(url, body);
            if(response.flag==200){
                setDriverData(response.data);
            }
            if(response.flag==102){
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);
                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
            }
        }
        catch (error) {
            console.log('error', error);
        }
    };

    const fetchVehicleData = async() => {
        try {
            const url = serverUrl + '/vehicle/fetch_vehicle_make';
            const token = localStorage.getItem('token');

            const timestamp = new Date().getTime();
            const body = {
                token: token,
                city_id: cityFilter,
                timestamp: timestamp
            };
            const response = await makeGetRequestToUrl(url, body);
            if(response.flag==200){
                setVehiclesMakeData(response.data);
            }
            if(response.flag==102){
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);

                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
            }
        } 
        catch (error) {
            console.log('error', error);
        }
    };

    useEffect(() => {
            fetchDriversData();
            fetchVehicleData();
    },[])
  const handleCancelBooking = async() => {
    const token = localStorage.getItem('token');
    const payload = {
      token: token,
      booking_id: selectedRow.booking_id,
    };
    try {
      const url = operationsUrl + '/airport/cancel_booking';
      const response = await makePostRequestToUrl(url,payload, null, 20000);
      if (response.flag === 200) {
        setMessage(response.message)
        showSnackbar(true);
        if (onFetchData) {
          onFetchData();
        }
      } else {
        setMessage(response.message)
        showSnackbar(true);
      }
      handleMenuClose();
    } catch (error) {
      console.error('Error', error);
      setMessage(error.message || 'An error occurred'); 
    }
  }

  const handleUnassignSubmit = async() => {
          const token = localStorage.getItem('token');
          // if(!assignDriver.driver_id || !assignDriver.vehicle_make_id){
          //     setMessage("Please select driver and vehicle make");
          //     showSnackbar(true);
          //     return;
          // }
          const payload = {
              token: token,
              booking_id: selectedRow.booking_id,
              driver_id: selectedRow.driver_id,
              vehicle_make_id: selectedRow.vehicle_make_id,
              is_unassigned: 1
          };
          setIsSaving(true);
          try {
              const url = operationsUrl + '/airport/assign_booking';
              const response = await makePostRequestToUrl(url, payload, null, 20000);
              
              if (response.flag === 200) {
              setMessage(`Trip Unassigned Successfully`);
              showSnackbar(true);
              setOpenUnassign(false);
              setSelectedRow(null);            
              if (onFetchData) {
                  onFetchData(); // Refresh the data
              }
              } else {
              setMessage(response.message || 'Failed to assign driver');
              showSnackbar(true);
              }
              handleMenuClose();
          } catch (error) {
              console.error('Error', error);
              setMessage(error.message || 'An error occurred'); 
            } finally {
              setIsSaving(false);
              showSnackbar(true);
          }
          }

  const handleDeleteBooking = async () => {
    const token = localStorage.getItem('token');
    const payload = {
      token: token,
      booking_id: selectedRow.booking_id,
      booking_status: -1,
    };
    try {
      const url = operationsUrl + '/airport/create_and_update_bookings';
      const response = await makePostRequestToUrl(url, payload, null, 20000);
      if (response.flag === 200) {
        setMessage(response.message)
        showSnackbar(true);
        setOpen(false);
        if (onFetchData) {
          onFetchData();
        }
      }
      else if(response.flag==102){
        localStorage.removeItem('token');
        // setErrorMessage('Your session has expired. Please log in again.');
        setTokenExpired(true);
        setTimeout(() => {
            navigate('/signup');
        }, 2000);
      } else {
        setMessage(response.message)
        showSnackbar(true);
      }
    } catch (error) {
      console.error('Error', error);
      setMessage(error.message || 'An error occurred'); 
    } finally {
      setUpdatingStatusFor(null);
    }
  };

  const handleCloseDetails = () => {
    setOpenViewDetails(false);
  }
  const handleOpenDetails = () => {
    setOpenViewDetails(true);
    setMenuAnchorEl(null);
  }


  const total = parseNum(selectedRow?.fare) + parseNum(selectedRow?.tax) + parseNum(selectedRow?.partner_fare) + parseNum(selectedRow?.extra_fare);
  return (
    <>
        <Dialog
            open={openCancelConfirmModal}
            onClose={() => setOpenCancelConfirmModal(false)}
            aria-labelledby="cancel-booking-dialog-title"
            aria-describedby="cancel-booking-dialog-description"
            PaperProps={{
                style: {
                    borderRadius: '12px',
                    padding: '10px'
                }
            }}
        >
            <DialogTitle id="cancel-booking-dialog-title" sx={{fontWeight:'bold'}}>Confirm Cancellation</DialogTitle>
            <DialogContent>
                <DialogContentText id="cancel-booking-dialog-description">
                    Are you sure you want to cancel this booking?
                </DialogContentText>
            </DialogContent>
            <DialogActions sx={{paddingBottom:'20px', paddingRight:'20px'}}>
                <Button 
                    onClick={() => setOpenCancelConfirmModal(false)} 
                    sx={{
                        color: '#6B7280', 
                        borderRadius:'8px', 
                        textTransform:'none',
                        border: '1px solid #D1D5DB',
                        '&:hover': {
                            backgroundColor: '#F3F4F6',
                            borderColor: '#9CA3AF'
                        }
                    }}
                >
                    No
                </Button>
                <Button 
                    onClick={() => {
                        handleCancelBooking(); // Calls the existing function which uses selectedRow
                        setOpenCancelConfirmModal(false);
                    }} 
                    color="error"
                    variant="contained"
                    sx={{ 
                        backgroundColor: '#EF4444', 
                        borderRadius:'8px', 
                        textTransform:'none',
                        '&:hover': {
                            backgroundColor: '#DC2626'
                        }
                    }}
                    autoFocus
                >
                    Yes
                </Button>
            </DialogActions>
        </Dialog>

        <Dialog
            open={openDeleteConfirmModal}
            onClose={() => setOpenDeleteConfirmModal(false)}
            aria-labelledby="delete-booking-dialog-title"
            aria-describedby="delete-booking-dialog-description"
            PaperProps={{
                style: {
                    borderRadius: '12px',
                    padding: '10px'
                }
            }}
        >
            <DialogTitle id="delete-booking-dialog-title" sx={{fontWeight:'bold'}}>Confirm Deletion</DialogTitle>
            <DialogContent>
                <DialogContentText id="delete-booking-dialog-description">
                    Are you sure you want to delete this booking permanently?
                    <br/> This cannot be undone.
                </DialogContentText>
            </DialogContent>
            <DialogActions sx={{paddingBottom:'20px', paddingRight:'20px'}}>
                <Button 
                    onClick={() => setOpenDeleteConfirmModal(false)} 
                    sx={{
                        color: '#6B7280', 
                        borderRadius:'8px', 
                        textTransform:'none',
                        border: '1px solid #D1D5DB',
                        '&:hover': {
                            backgroundColor: '#F3F4F6',
                            borderColor: '#9CA3AF'
                        }
                    }}
                >
                    No
                </Button>
                <Button 
                    onClick={() => {
                        handleDeleteBooking();
                        setOpenDeleteConfirmModal(false);
                    }} 
                    color="error"
                    variant="contained"
                    sx={{ 
                        backgroundColor: '#EF4444', 
                        borderRadius:'8px', 
                        textTransform:'none',
                        '&:hover': {
                            backgroundColor: '#DC2626'
                        }
                    }}
                    autoFocus
                >
                    Yes
                </Button>
            </DialogActions>
        </Dialog>

        <Dialog
            open={openMarkNoShowConfirmModal}
            onClose={() => setOpenMarkNoShowConfirmModal(false)}
            aria-labelledby="cancel-booking-dialog-title"
            aria-describedby="cancel-booking-dialog-description"
            PaperProps={{
                style: {
                    borderRadius: '12px',
                    padding: '10px'
                }
            }}
        >
            <DialogTitle id="cancel-booking-dialog-title" sx={{fontWeight:'bold'}}>Mark No Show</DialogTitle>
            <DialogContent>
                <DialogContentText id="cancel-booking-dialog-description">
                    Are you sure you want to mark this trip as no show?
                </DialogContentText>
            </DialogContent>
            <DialogActions sx={{paddingBottom:'20px', paddingRight:'20px'}}>
                <Button 
                    onClick={() => setOpenMarkNoShowConfirmModal(false)} 
                    sx={{
                        color: '#6B7280', 
                        borderRadius:'8px', 
                        textTransform:'none',
                        border: '1px solid #D1D5DB',
                        '&:hover': {
                            backgroundColor: '#F3F4F6',
                            borderColor: '#9CA3AF'
                        }
                    }}
                >
                    No
                </Button>
                <Button 
                    onClick={() => {
                        if (bookingtomarkNoShow) { // Ensure bookingToCancel is set
                            // Temporarily set selectedRow for handleCancelBooking if it strictly relies on it
                            // This is a bit of a workaround if handleCancelBooking isn't updated to use bookingToCancel directly
                            const originalSelectedRow = selectedRow;
                            setSelectedRow(bookingtomarkNoShow);
                            handleMarkNoShowBooking();
                            setSelectedRow(originalSelectedRow); // Restore original selectedRow if necessary
                        }
                        setOpenMarkNoShowConfirmModal(false);
                    }} 
                    color="error"
                    variant="contained"
                    sx={{ 
                        backgroundColor: '#EF4444', 
                        borderRadius:'8px', 
                        textTransform:'none',
                        '&:hover': {
                            backgroundColor: '#DC2626'
                        }
                    }}
                    autoFocus
                >
                    Yes
                </Button>
            </DialogActions>
        </Dialog>

        <Dialog
            open={openUnassign}
            onClose={() => setOpenUnassign(false)}
            aria-labelledby="unassign-booking-dialog-title"
            aria-describedby="unassign-booking-dialog-description"
            PaperProps={{
                style: {
                    borderRadius: '12px',
                    padding: '10px'
                }
            }}
        >
            <DialogTitle id="unassign-booking-dialog-title" sx={{fontWeight:'bold'}}>Unassign Trip Confirmation</DialogTitle>
            <DialogContent>
                <DialogContentText id="unassign-booking-dialog-description">
                    Are you sure you want to unassign this trip? 
                    <br/>
                </DialogContentText>
            </DialogContent>
            <DialogActions sx={{paddingBottom:'20px', paddingRight:'20px'}}>
                <Button 
                    onClick={() => setOpenUnassign(false)} 
                    sx={{
                        color: '#6B7280', 
                        borderRadius:'8px', 
                        textTransform:'none',
                        border: '1px solid #D1D5DB',
                        '&:hover': {
                            backgroundColor: '#F3F4F6',
                            borderColor: '#9CA3AF'
                        }
                    }}
                >
                    No
                </Button>
                <Button 
                    onClick={() => {
                        if (unassignDriver) { // Ensure bookingToCancel is set
                            // Temporarily set selectedRow for handleCancelBooking if it strictly relies on it
                            // This is a bit of a workaround if handleCancelBooking isn't updated to use bookingToCancel directly
                            const originalSelectedRow = selectedRow;
                            setSelectedRow(unassignDriver);
                            handleUnassignSubmit();
                            setSelectedRow(originalSelectedRow); // Restore original selectedRow if necessary
                        }
                        setOpenUnassign(false);
                    }} 
                    color="error"
                    variant="contained"
                    sx={{ 
                        backgroundColor: '#EF4444', 
                        borderRadius:'8px', 
                        textTransform:'none',
                        '&:hover': {
                            backgroundColor: '#DC2626'
                        }
                    }}
                    autoFocus
                >
                    Yes
                </Button>
            </DialogActions>
        </Dialog>


      {openAssignModal && (
        <div 
        style={{position: 'fixed',top: 65, right:0, height: '100%',width: '38%',backgroundColor: '#f9f9f9',
            boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)',transition: 'right 0.3s ease-in-out',
            zIndex: 1000,overflowY: 'auto',padding: 20
        }}>
          <Box>
            <div style={{ position: 'relative', padding: '40px 0' }}>
              <IconButton aria-label="close" onClick={handleClose}
                  style={{
                      position: 'absolute',top: '-15px',left: '1px',color: '#333',zIndex: 10}}>
                  <CloseIcon style={{ fontSize: '32px', fontWeight: 'bold' }} />
              </IconButton>
              
              <Paper sx={{borderRadius:'12px', padding:'16px'}}>
                <Typography style={{ marginBottom: '6px', marginTop: '6px', fontWeight: '500', fontSize:'24px' }}>
                  Assign Driver
                </Typography>

              <Grid container spacing={2} sx={{marginTop:'3%', marginBottom:'2%'}}>
                <Grid item xs={12} sm={12}>
                  <Label>Assign Driver</Label>
                  <Select 
                      sx={{
                        marginTop:'2%',
                        height: '48px', 
                        borderRadius: '8px', 
                        backgroundColor: '#FFFFFF',
                        '& .MuiSelect-select': {
                          display: 'flex',
                          alignItems: 'center',
                          paddingLeft: '12px'
                        }
                      }}
                      value={assignDriver.driver_id} 
                      fullWidth
                      displayEmpty
                      renderValue={(selected) => {
                        return (
                          <Box sx={{ display: 'flex', alignItems: 'center' }}>
                            <PersonIcon sx={{ color: '#666', mr: 1 }} />
                            {selected ? driverData.find(driver => driver.driver_id === selected)?.driver_name : 'Select Driver'}
                          </Box>
                        );
                      }}
                      onChange={(e) => {
                        const selectedDriver = driverData.find(driver => driver.driver_id === e.target.value);
                        setAssignDriver(prevAssignDriver => ({
                            ...prevAssignDriver,
                            driver_id: selectedDriver.driver_id,
                            // Only update vehicle_make_id from driver if no vehicle is already selected OR if the driver's vehicle is different
                            // This prioritizes an explicitly chosen vehicle over the driver's default.
                            // However, if the user picks a driver first, their default vehicle should populate.
                            // A simpler approach: if a vehicle is already set, don't override it when changing driver.
                            vehicle_make_id: prevAssignDriver.vehicle_make_id && prevAssignDriver.vehicle_make_id !== '' 
                                             ? prevAssignDriver.vehicle_make_id 
                                             : selectedDriver.vehicle_make_id || ''
                        }));
                      }}>
                      <MenuItem value="" disabled>
                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                          <PersonIcon sx={{ color: '#666', mr: 1 }} />
                          Select Driver
                        </Box>
                      </MenuItem>
                      {driverData && driverData.map((driver) => (
                        <MenuItem key={driver.driver_id} value={driver.driver_id}>
                          {driver.driver_name}
                        </MenuItem>
                      ))}
                  </Select>
                </Grid>

                <Grid item xs={12} sm={12}>
                    <Label>Select Vehicle</Label>
                    <Select 
                      sx={{
                        marginTop:'2%',
                        height: '48px', 
                        borderRadius: '8px', 
                        backgroundColor: '#FFFFFF',
                        '& .MuiSelect-select': {
                          display: 'flex',
                          alignItems: 'center',
                          paddingLeft: '12px'
                        }
                      }}
                      value={editVehicleMakeId || assignDriver.vehicle_make_id || ''} 
                      fullWidth
                      displayEmpty
                      renderValue={(selected) => {
                        const selectedVehicle = vehiclesMakeData?.find(vehicle => 
                          vehicle.vehicle_make_id === selected || vehicle.id === selected);
                        
                        return (
                          <Box sx={{ display: 'flex', alignItems: 'center' }}>
                            <img src={blueCarIcon} alt="Vehicle" style={{ marginRight: '8px', width: '30px', height: '30px' }} />
                            {selected && selectedVehicle ? selectedVehicle.vehicle_number : 'Select Vehicle'}
                          </Box>
                        );
                      }}
                      onChange={(e) => {
                          const selectedId = e.target.value;
                          setEditVehicleMakeId(selectedId);
                          
                          // Find the selected vehicle and update assignDriver
                          const selectedVehicle = vehiclesMakeData.find(vehicle => 
                              vehicle.vehicle_make_id === selectedId || vehicle.id === selectedId);
                          if (selectedVehicle) {
                              // Update assignDriver with the new vehicle info
                              setAssignDriver(prev => ({
                                  ...prev,
                                  vehicle_make_id: selectedVehicle.vehicle_make_id || selectedVehicle.id,
                                  model_name: selectedVehicle.model_name || '', 
                                  vehicle_number: selectedVehicle.vehicle_number || ''
                              }));
                          }
                      }}>
                      <MenuItem value="" disabled>
                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                          <img src={blueCarIcon} alt="Vehicle" style={{ marginRight: '8px', width: '24px', height: '24px' }} />
                          Select Vehicle
                        </Box>
                      </MenuItem>
                      {vehiclesMakeData && vehiclesMakeData.map((vehicleMake) => (
                        <MenuItem key={vehicleMake.id || vehicleMake.vehicle_make_id} 
                          value={vehicleMake.id || vehicleMake.vehicle_make_id}>
                          <Box sx={{ display: 'flex', alignItems: 'center' }}>
                            {vehicleMake.vehicle_number}
                          </Box>
                        </MenuItem>
                      ))}
                    </Select>
                </Grid>
              </Grid>
              
              <div style={{ marginTop: '12%', display: 'flex', justifyContent: 'center', gap: '20px', marginBottom:'6%' }}>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleSubmit}
                  disabled={isSaving}
                  sx={{
                    width: '140px',
                    height: '50px',
                    textTransform: 'none',
                    fontSize: '16px',
                    backgroundColor: isSaving ? '#BDBDBD' : '#0065FF',
                    color: 'white',
                    '&:disabled': {
                      backgroundColor: '#BDBDBD',
                      color: 'white',
                    }
                  }}>
                  {isSaving ? 'Saving...' : 'Done'}
                </Button>
                <Button
                  variant="contained"
                  onClick={handleClose}
                  sx={{
                    width: '140px',
                    height: '50px',
                    textTransform: 'none',
                    fontSize: '16px',
                    backgroundColor: '#F0F0F0',
                    color: '#B0B0B0',
                  }}
                >
                  Cancel
                </Button>
              </div>

              </Paper>
            </div>
          </Box>
        </div>
      )}
    
      <TableContainer className="table-container" sx={{ marginTop: '0px', maxHeight:'56vh' }}>
        <Table stickyHeader className="scrollable-table">
          <TableHead>
            <TableRow>
              {visibleHeaders.map((header) => (
                <TableCell key={header} align="center" className="table-header" style={{ width: '15%' }}>
                  {header === 'Action' ? (
                    header
                  ) : (
                    <TableSortLabel
                      active={orderBy === headerToField[header]}
                      direction={orderBy === headerToField[header] ? order : 'asc'}
                      onClick={() => handleRequestSort(headerToField[header])}
                    >
                      {header}
                    </TableSortLabel>
                  )}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {sortedRows.length === 0 && (
              <TableRow>
                <TableCell colSpan={24} align="center">
                    <Typography variant="body1">No data found</Typography>
                </TableCell>
              </TableRow>
            )}
            {sortedRows.map((row) => {
              const total = parseNum(row.fare) + parseNum(row.tax) + parseNum(row.partner_fare) + parseNum(row.extra_fare);
            return (
              <TableRow 
                key={row.id}
                hover
                sx={{
                  // Apply styles based on booking status only when onEditBooking is undefined
                  ...(vehicleMakeData === undefined && {
                    '& > td': { // Apply styles to all cells in this row
                      backgroundColor: constants.airportBookingBgColors[row.booking_status] || 'inherit',
                    },
                    borderLeft: (() => {
                      // Get solid color for left border from constants
                      const color = constants.airportBookingSolidColors[row.booking_status];
                      return color ? `4px solid ${color}` : 'none';
                    })()
                  })
                }}
              >
                {visibleHeaders.map((header) => {
                    switch (header) {
                      case 'Booking ID':
                        return (
                            <TableCell align="center">
                              <Typography sx={{ minWidth: '100px' }}>{row.booking_id}</Typography>
                            </TableCell>);
                case 'Booking Mode':
                        return (
                <TableCell align="center">
                  <Typography sx={{ minWidth: '100px', color: row.source==1 ? '#0C3B7C' : row.source==2 ? '#AC8312' : row.source==0 ? '#8f8c81' : row.source==-1 ? '#0065FF' : '#0065FF' }}>
                    {row.source==1 ? 'PIU' : row.source==2 ? 'Transferz' : row.source==0 ? 'Others' : row.source==-1 ? 'Admin Panel' : 'Unknown'}
                  </Typography>
                </TableCell>);
                case 'Source ID':
                        return (
                <TableCell align="center">
                  <Typography sx={{ minWidth: '100px' }}>{row.source_id ? row.source_id : '--'}</Typography>
                </TableCell>);
                case 'User':
                        return (
                <TableCell align="center">
                  <Grid2 container sx={{ minWidth: '180px' }}>
                    <Grid2>
                      {row.user_image && <Avatar sx={{ borderColor: '#0065FF', border: 1 }} alt="name" src={row.user_image} />}
                      {!row.user_image && <Avatar sx={{ borderColor: '#0065FF', border: 1 }} alt="name" src={altProfile} />}
                    </Grid2>
                    <Grid2 item sx={{ ml: '8px', textAlign: 'left' }}>
                      <Typography>{row.user_first_name + ' ' + row.user_last_name}</Typography>
                      <Typography sx={{ color: '#83888E', fontSize: '12px' }}>{row.user_phone_number}</Typography>
                    </Grid2>
                  </Grid2>
                </TableCell>);
                case 'Driver':
                        return (
                <TableCell align="center">
                  {row.driver_name &&
                    <Grid2 container sx={{ minWidth: '180px' }}>
                      <Grid2>
                        {row.driver_image && <Avatar sx={{ borderColor: '#0065FF', border: 1 }} alt="name" src={row.driver_image} />}
                        {!row.driver_image && <Avatar sx={{ borderColor: '#0065FF', border: 1 }} alt="name" src={altProfile} />}
                      </Grid2>
                      <Grid2 item sx={{ ml: '8px', textAlign: 'left' }}>
                        <Typography>{row.driver_name}</Typography>
                        <Typography sx={{ color: '#83888E', fontSize: '12px' }}>{row.driver_phone}</Typography>
                      </Grid2>
                    </Grid2>
                  }
                  {!row.driver_name && 
                    <Typography sx={{ minWidth: '100px' }}>--</Typography>
                  }
                </TableCell>);
                case 'User Email':
                        return (
                <TableCell align="center"><Typography sx={{ minWidth: '100px' }}>{row.user_email}</Typography></TableCell>);
                case 'Date & Time':
                        return (
                          <TableCell align="center">
                            <Typography sx={{ minWidth: '100px' }}>
                              {row.pickup_time ? 
                                (() => {
                                  const pickupDate = new Date(row.pickup_time);
                                  // Add the offset minutes to the date
                                  pickupDate.setMinutes(pickupDate.getMinutes() + utcOffset);
                                  return pickupDate.toLocaleString('en-GB', {
                                    day: '2-digit', 
                                    month: '2-digit', 
                                    year: 'numeric', 
                                    hour: '2-digit', 
                                    minute: '2-digit', 
                                    hour12: timeZoneFormat == '12' ? true : false,
                                    timeZone: 'UTC'
                                  }).replace(',', ' |');
                                })() 
                                : '--'
                              }
                            </Typography>
                          </TableCell>
                        );
                case 'Pickup Address':
                        return (
                <TableCell align="center"><Typography sx={{ minWidth: '100px', fontWeight: 500 }}>{row.pickup_address}</Typography></TableCell>);
                case 'Drop Address':
                        return (<TableCell align="center"><Typography sx={{ minWidth: '100px' }}>{row.drop_address}</Typography></TableCell>);
                case 'Stops':
                        return (<TableCell align="center" sx={{minWidth:'200px'}}>
                {row?.way_points?.map((item, index) => (
                  <div key={index}>
                    {(index!=0 && index!=row.way_points.length-1) && 
                      <Typography variant="subtitle2">{`${index}`} )  <span style={{fontWeight:600}}>{item.address}</span></Typography>
                    }<br/>
                  </div>
                ))}

                {row.way_points==null && <Typography variant="subtitle2">--</Typography>}
                </TableCell>);
                case 'Flight Number':
                        return (<TableCell align="center"><Typography sx={{ minWidth: '100px' }}>{row.flight_number ? row.flight_number : '--'}</Typography></TableCell>);
                case 'Vehicle Number':
                        return (<TableCell align="center"><Typography sx={{ minWidth: '100px' }}>{row.vehicle_number ? row.vehicle_number : '--'}</Typography></TableCell>);

                case 'Luggage Count':
                        return (<TableCell align="center"><Typography sx={{ minWidth: '100px' }}>{row.luggage_count ? row.luggage_count : '--'}</Typography></TableCell>);
                case 'Number of Seats':
                        return (<TableCell align="center"><Typography sx={{ minWidth: '100px' }}>{row.ticket_count}</Typography></TableCell>);
                case 'Distance (in km)':
                        return (<TableCell align="center"><Typography sx={{ minWidth: '100px' }}>{(ischange_point_to_comma == 1 ? formatNumberWithComma(row.distance): formatNumberWithdecimal(row.distance))}</Typography></TableCell>);
                case 'Duration (in min)':
                        return (<TableCell align="center"><Typography sx={{ minWidth: '100px' }}>{row.duration}</Typography></TableCell>);
                case 'Fare':
                        return (<TableCell align="center"><Typography sx={{ minWidth: '100px' }}>€ {(ischange_point_to_comma == 1 ? formatNumberWithComma(parseNum(row.fare).toFixed(2)): formatNumberWithdecimal(parseNum(row.fare).toFixed(2)))}</Typography></TableCell>);
                case 'Tax':
                        return (<TableCell align="center"><Typography sx={{ minWidth: '100px' }}>{row.tax? '€ ' + (ischange_point_to_comma == 1 ? formatNumberWithComma(parseNum(row.tax).toFixed(2)): formatNumberWithdecimal(parseNum(row.tax).toFixed(2))):'--'}</Typography></TableCell>);
                case 'Partner Price':
                        return (<TableCell align="center"><Typography sx={{ minWidth: '100px' }}>{row.partner_fare? '€ ' + (ischange_point_to_comma == 1 ? formatNumberWithComma(parseNum(row.partner_fare).toFixed(2)): formatNumberWithdecimal(parseNum(row.partner_fare).toFixed(2))):'--'}</Typography></TableCell>);
                case 'Extras':
                        return (<TableCell align="center"><Typography sx={{ minWidth: '100px' }}>{row.extra_fare? '€ ' + (ischange_point_to_comma == 1 ? formatNumberWithComma(parseNum(row.extra_fare).toFixed(2)): formatNumberWithdecimal(parseNum(row.extra_fare).toFixed(2))):'--'}</Typography></TableCell>);
                case 'Total Fare':
                        return (
                        <TableCell align="center" sx={{ verticalAlign: 'middle', minWidth:'100px' }}>
                          <Box sx={{ display: 'inline-flex', alignItems: 'center' }}>
                            <Typography sx={{ color:'#0065ff', marginRight:'8px' }}>
                              {'€ ' + (ischange_point_to_comma == 1 ? formatNumberWithComma(Number(total).toFixed(2)) : formatNumberWithdecimal(Number(total).toFixed(2)))}
                            </Typography>
                            {row.payment_status==1 && <img height="16px" width="16px" src={greenTic} alt="greenTic" />}
                          </Box>
                        </TableCell> );
                case 'Payment Mode':
                        return (<TableCell align="center"><Typography sx={{ minWidth: '100px' }}>{row.payment_mode==1 ? 'Cash' : row.payment_mode==2 ? 'Prepaid' : '--'}</Typography></TableCell>  );
                case 'Payment Status':
                        return (<TableCell align="center"><Typography sx={{ minWidth: '100px', color: row.payment_status==1 ? 'green' : '#AC8312' }}>{row.payment_status==0 ? 'Pending' : row.payment_status==1 ? 'Paid' : 'Pending'}</Typography></TableCell>);
                case 'Status':
                        return (<TableCell align="center">
                  <Typography 
                    sx={{ 
                      minWidth: '100px', marginLeft:'8px', marginRight:'8px',
                      backgroundColor: constants.airportBookingSolidColors[row.booking_status] || 'transparent',
                      color: row.booking_status ? 'white' : 'inherit',
                      padding: '4px 8px',
                      borderRadius: '4px',
                      display: 'inline-block'
                    }}
                  >
                    {(() => {
                      // Use constants.airportBookingStatus but handle by code
                      // Special case for status 5 since it's a duplicate key in the constants
                      if (row.booking_status === 5) {
                        return "Cancelled";
                      }
                      
                      // Find the status name by code
                      for (const [statusName, statusCode] of Object.entries(constants.airportBookingStatus)) {
                        if (statusCode === row.booking_status) {
                          // Format the status name (e.g., "PENDING" becomes "Pending")
                          return statusName.charAt(0) + statusName.slice(1).toLowerCase().replace(/_/g, " ");
                        }
                      }
                      return 'Unknown';
                    })()}
                  </Typography>
                </TableCell>);
                case 'Parent Booking ID':
                        return (<TableCell align="center"><Typography sx={{ minWidth: '100px' }}>{row.linked_booking_id==0 ? '--' : row.linked_booking_id}</Typography></TableCell>);
                case 'Journey Code':
                        return (<TableCell align="center"><Typography sx={{ minWidth: '100px' }}>{row.journey_code	 ? row.journey_code	 : '--'}</Typography></TableCell>);
                case 'Consent Form URL':
                        return (<TableCell align="center">
                            {row.consent_form_url && <Button size="small" onClick={() => window.open(row.consent_form_url, '_blank')}>View</Button>}
                            {!row.consent_form_url && <Typography>--</Typography>}
                        </TableCell>);
                case 'Action':
                  // if (onEditBooking !== undefined) {
                    return (
                  <TableCell sx={{ padding: 0, verticalAlign: 'middle' }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%' }}>
                        
                        {(row.booking_status===1 && onEditBooking !== undefined) && (
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, justifyContent: 'center' }}>
                            <Button
                              onClick={() => handleBookingStatus(row, 'accept')}
                              variant="contained"
                              disabled={updatingStatusFor === row.booking_id}
                              sx={{
                                backgroundColor: '#EFFBF7', color: '#0DBA78', border: '1px solid #0DBA78', textTransform: 'none',
                                borderRadius: '8px', minWidth: '40px', boxShadow: 'none', width: "90px",
                                '&:hover': { backgroundColor: '#0DBA78', color: 'white' },
                                marginRight:'4px',
                                '&.Mui-disabled': {
                                  backgroundColor: '#BDBDBD',
                                  color: 'white',
                                  border: '1px solid #BDBDBD'
                                }
                              }}
                            >
                              <Typography sx={{ marginRight: '6%' }}>Accept</Typography>
                            </Button>

                            <Button
                              onClick={() => handleBookingStatus(row, 'reject')}
                              disabled={updatingStatusFor === row.booking_id}
                              sx={{
                                color: '#D14545', border: '1px solid #D14545', textTransform: 'none',
                                borderRadius: '8px', minWidth: '40px', boxShadow: 'none', width: "90px",
                                '&:hover': { backgroundColor: '#D14545', color: 'white' },
                                marginRight:'4px',
                                '&.Mui-disabled': {
                                  backgroundColor: '#BDBDBD',
                                  color: 'white',
                                  border: '1px solid #BDBDBD'
                                }
                              }}
                            >
                              <Typography sx={{ marginRight: '6%' }}>Reject</Typography>
                            </Button>
                          </Box>
                        )}
                        {(row.booking_status=== 2 && onEditBooking !== undefined) && (
                          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            <Button onClick={() => handleOpenAssignModal(row)}
                              sx={{
                                color: '#0065ff', border: '1px solid #0065ff', textTransform: 'none',
                                borderRadius: '8px', minWidth: '40px', boxShadow: 'none', width: "140px",
                                '&:hover': { backgroundColor: '#0065ff', color: 'white' },
                                '&:active': { backgroundColor: '#0065ff', color: 'white' }, marginRight:'4px'
                              }}
                            >
                            <Typography sx={{ marginRight: '6%' }}>Assign to driver</Typography>
                            </Button>
                            
                          </Box>
                        )}
                        {(row.booking_status === 1 && onEditBooking === undefined) && (
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, justifyContent: 'center' }}>
                            <Button
                              onClick={() => handleBookingStatus(row, 'accept')}
                              variant="contained"
                              disabled={updatingStatusFor === row.booking_id}
                              sx={{
                                backgroundColor: '#EFFBF7', color: '#0DBA78', border: '1px solid #0DBA78', textTransform: 'none',
                                borderRadius: '8px', minWidth: '40px', boxShadow: 'none', width: "90px",
                                '&:hover': { backgroundColor: '#0DBA78', color: 'white' },
                                marginRight:'4px',
                                '&.Mui-disabled': {
                                  backgroundColor: '#BDBDBD',
                                  color: 'white',
                                  border: '1px solid #BDBDBD'
                                }
                              }}
                            >
                              <Typography sx={{ marginRight: '6%' }}>Accept</Typography>
                            </Button>

                            <Button
                              onClick={() => handleBookingStatus(row, 'reject')}
                              disabled={updatingStatusFor === row.booking_id}
                              sx={{
                                color: '#D14545', border: '1px solid #D14545', textTransform: 'none',
                                borderRadius: '8px', minWidth: '40px', boxShadow: 'none', width: "90px",
                                '&:hover': { backgroundColor: '#D14545', color: 'white' },
                                marginRight:'4px',
                                '&.Mui-disabled': {
                                  backgroundColor: '#BDBDBD',
                                  color: 'white',
                                  border: '1px solid #BDBDBD'
                                }
                              }}
                            >
                              <Typography sx={{ marginRight: '6%' }}>Reject</Typography>
                            </Button>
                          </Box>
                        )}
                        {(row.booking_status=== 2 && onEditBooking === undefined) && (
                          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            <Button onClick={() => handleOpenAssignModal(row)}
                              sx={{
                                color: '#0065ff', border: '1px solid #0065ff', textTransform: 'none',
                                borderRadius: '8px', minWidth: '40px', boxShadow: 'none', width: "140px",
                                '&:hover': { backgroundColor: '#0065ff', color: 'white' },
                                '&:active': { backgroundColor: '#0065ff', color: 'white' }, marginRight:'4px'
                              }}
                            >
                            <Typography sx={{ marginRight: '6%' }}>Assign to driver</Typography>
                            </Button>
                            
                          </Box>
                        )}
                        {((row.booking_status===3 && onEditBooking !== undefined) || row.booking_status===6) && (
                          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            
                          </Box>
                        )}

                        <IconButton
                          aria-label="more options" 
                          size="small"
                          onClick={(e) => handleMenuOpen(e, row)}
                          sx={{ padding: 0, marginLeft: '4px', display: 'flex', alignItems: 'center' }}
                        >
                          <img src={threeDots} alt="threeDots" style={{ display: 'block' }}/>
                        </IconButton>
                      </Box>
                    
                    <Menu
                        anchorEl={menuAnchorEl}
                        open={Boolean(menuAnchorEl) && selectedRow?.tms_client_id === row.tms_client_id}
                        onClose={handleMenuClose}
                        PaperProps={{
                            elevation: 3,
                            sx: {
                                borderRadius: '8px',
                                minWidth: '160px',
                                padding: '4px 0',
                                overflow: 'visible',
                                '&:before': {
                                    content: '""',
                                    display: 'block',
                                    position: 'absolute',
                                    top: 0,
                                    right: 14,
                                    width: 10,
                                    height: 10,
                                    bgcolor: 'background.paper',
                                    transform: 'translateY(-50%) rotate(45deg)',
                                    zIndex: 0,
                                },
                            },
                        }}
                        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
                    >

                        <MenuItem 
                          onClick={() => handleOpenDetails()} 
                          sx={{ py: 1 }}>
                          <ListItemText primary="View Details" sx={{ color: '#6B7280' }} />
                        </MenuItem>
                        {(selectedRow?.booking_status == 1 || selectedRow?.booking_status == 2 || selectedRow?.booking_status == 6 || selectedRow?.booking_status == 8 || selectedRow?.booking_status == 12 || selectedRow?.booking_status == 13) && (
                          <MenuItem 
                            onClick={() => handleOpenEdit()} 
                            sx={{ py: 1 }}>
                            <ListItemText primary="Edit" sx={{ color: '#6B7280' }} />
                            <ListItemIcon>
                                <ModeEditIcon sx={{fontSize:'medium'}} />
                            </ListItemIcon>
                          </MenuItem>
                        )}
                        {(selectedRow?.booking_status == 6 || selectedRow?.booking_status == 8 || selectedRow?.booking_status == 12 || selectedRow?.booking_status == 13) && (
                          <>
                              <MenuItem onClick={() => openConfirmDialog('reassign')} sx={{ py: 1 }}>
                                  <ListItemText primary="Reassign" sx={{ color: '#6B7280' }} />
                              </MenuItem>
                              <MenuItem onClick={() => openConfirmDialog('unassign')} sx={{ py: 1 }}>
                                  <ListItemText primary="Unassign" sx={{ color: '#6B7280' }} />
                              </MenuItem>
                          </>
                        )}
                        {(selectedRow?.booking_status == 6 || selectedRow?.booking_status == 8 || selectedRow?.booking_status == 12 || selectedRow?.booking_status == 13) && (
                          <MenuItem onClick={() => openConfirmDialog('marknoshow', row)} sx={{ py: 1 }}>
                          <ListItemText primary="Mark No Show" sx={{ color: '#6B7280' }} />
                          </MenuItem>
                        )}
                        {(selectedRow?.booking_status == 3 || selectedRow?.booking_status == 1 || selectedRow?.booking_status == 2 || selectedRow?.booking_status == 6)  && 
                          <MenuItem 
                            onClick={() => {
                                setBookingToCancel(selectedRow); // Set for dialog context, though handleCancelBooking uses selectedRow
                                setOpenCancelConfirmModal(true);
                                handleMenuClose();
                            }} 
                            sx={{ py: 1 }}>
                            <ListItemText primary="Cancel" sx={{ color: '#6B7280' }} />
                            <ListItemIcon>
                                <img src={deleteImg} alt="delete"/>
                            </ListItemIcon>
                          </MenuItem>
                        }

                        {(selectedRow?.booking_status == 6 || selectedRow?.booking_status == 8 || selectedRow?.booking_status == 9 || selectedRow?.booking_status == 10 || selectedRow?.booking_status == 11 || selectedRow?.booking_status == 5 || selectedRow?.booking_status == 1 || selectedRow?.booking_status == 2 || selectedRow?.booking_status == 3 || selectedRow?.booking_status == 12 || selectedRow?.booking_status == 13) && (
                          <MenuItem onClick={() => openConfirmDialog('delete', row)} sx={{ py: 1 }}>
                                  <ListItemText primary="Delete Booking" sx={{ color: '#D14545' }} />
                              </MenuItem>
                        )}
                    </Menu>
                  </TableCell>);
                // }
                return null;
                      default:
                        return <TableCell key={header}></TableCell>;
                    }
                  })}
                </TableRow>
            );
        })}
          </TableBody>
        </Table>
        {/* <div className="custom-pagination">
          <div className="pagination-info">
              {`Showing ${page * rowsPerPage + 1} to ${Math.min(
                  (page + 1) * rowsPerPage,
                  rows.length
              )} of ${rows.length} entries`}
          </div>
          <div className="pagination-controls">
              <button
                  onClick={() => handleChangePage(null, page - 1)}
                  disabled={page === 0}
                  className="pagination-arrow"
              >
                  <img src={prevIcon} alt="Previous" />
              </button>
              <div className="pagination-numbers">
                  {[...Array(Math.ceil(rows.length / rowsPerPage))].map((_, index) => (
                      <button key={index} onClick={() => handleChangePage(null, index)}
                          className={`pagination-number ${page === index ? 'active' : ''}`}>
                          {index + 1}
                      </button>
                  ))}
              </div>
              <button
                  onClick={() => handleChangePage(null, page + 1)}
                  disabled={page >= Math.ceil(rows.length / rowsPerPage) - 1}
                  className="pagination-arrow"
              >
                  <img src={nextIcon} alt="Next" />
              </button>
          </div>
        </div> */}
      </TableContainer>

      <div
          style={{
              position: 'fixed',
              top: 65,
              right: openViewDetails ? 0 : '-100%',
              height: '100%',
              width: '50%',
              backgroundColor: '#f9f9f9',
              boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)',
              transition: 'right 0.3s ease-in-out',
              zIndex: 1000,
              overflowY: 'auto',
              padding: 20
          }}
      >
          <Box onClose={handleCloseDetails}>
              <div style={{ position: 'relative', padding: '40px 0' }}>
                  {/* Close Button Outside the Card */}
                  <IconButton
                      aria-label="close"
                      onClick={handleCloseDetails}
                      style={{
                          position: 'absolute',
                          top: '-15px', // Position it above the Paper component
                          left: '1px',
                          color: '#333',
                          zIndex: 10,
                      }}
                  >
                      <CloseIcon style={{ fontSize: '32px', fontWeight: 'bold' }} />
                  </IconButton>
                  <Box sx={{ 
                          maxWidth: '800px', 
                          margin: '0 auto',
                          position: 'relative',
                          marginBottom: '20px',
                          boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)'
                      }}>
                      <Paper 
                          elevation={0}
                          style={{ 
                              padding: '30px', 
                              backgroundColor: '#FFFFFF', 
                              borderRadius: '12px',
                              border: '1px solid #E0E0E0',
                              position: 'relative'
                          }}>
                      <Typography style={{ marginBottom: '10px', fontWeight: '500', fontSize:'24px' }}>
                          Booking Details
                      </Typography>
                      <hr/>

                      <Grid2 container spacing={2}>
                          <Grid2 item>
                              <Button variant="contained" sx={{backgroundColor:'#0065ff', borderRadius:'8px', textTransform:'none'}}>Booking ID: {selectedRow?.booking_id}</Button>
                          </Grid2>
                          <Grid2 item sx={{border: selectedRow?.booking_status==1 ? '1px solid #F5BB19' : selectedRow?.booking_status==2 ? '1px solid #0DBA78' : selectedRow?.booking_status==3 ? '1px solid #D14545' : selectedRow?.booking_status==4 ? '1px solid #D14545' : selectedRow?.booking_status==5 ? '1px solid #D14545' : selectedRow?.booking_status==6 ? '1px solid #0065FF' : selectedRow?.booking_status==7 ? '1px solid #F5BB19' : selectedRow?.booking_status==8 ? '1px solid #F5BB19' : selectedRow?.booking_status==9 ? '1px solid #0DBA78' : selectedRow?.booking_status==10 ? '1px solid #D14545' : selectedRow?.booking_status==11 ? '1px solid #D14545' : selectedRow?.booking_status==12 ? '1px solid #f3a10a' : selectedRow?.booking_status==13 ? '1px solid #efc93f' : '1px solid #D14545', borderRadius:'8px', padding:'6px 12px'}}>
                              <Typography sx={{color: selectedRow?.booking_status==1 ? '#F5BB19' : selectedRow?.booking_status==2 ? '#0DBA78' : selectedRow?.booking_status==3 ? '#D14545' : selectedRow?.booking_status==4 ? '#D14545' : selectedRow?.booking_status==5 ? '#D14545' : selectedRow?.booking_status==6 ? '#0065FF' : selectedRow?.booking_status==7 ? '#F5BB19' : selectedRow?.booking_status==8 ? '#F5BB19' : selectedRow?.booking_status==9 ? '#0DBA78' : selectedRow?.booking_status==10 ? '#D14545' : selectedRow?.booking_status==11 ? '#D14545' : selectedRow?.booking_status==12 ? '#f3a10a' : selectedRow?.booking_status==13 ? '#efc93f' : '#D14545'}}>
                                {selectedRow?.booking_status==1 ? 'Pending' : selectedRow?.booking_status==2 ? 'Approved' : selectedRow?.booking_status==3 ? 'Rejected' : selectedRow?.booking_status==4 ? 'Missed' : selectedRow?.booking_status==5 ? 'Cancelled' : selectedRow?.booking_status==6 ? 'Assigned' : selectedRow?.booking_status==7 ? 'Unassigned' : selectedRow?.booking_status==8 ? 'Started' : selectedRow?.booking_status==9 ? 'Ended' : selectedRow?.booking_status==10 ? 'Cancelled' : selectedRow?.booking_status==11 ? 'No Show' : selectedRow?.booking_status==12 ? 'Arrived at Pickup' : selectedRow?.booking_status==13 ? 'Journey Started' : 'Unknown'}
                              </Typography>
                          </Grid2>
                      </Grid2>

                      <Grid2>
                          <Typography sx={{fontSize:'20px', fontWeight:'500', marginTop:'20px'}}>User Details</Typography>

                          <Grid2 container spacing={2} sx={{ marginTop:'16px', alignItems:'center', marginBottom:'16px'}} size={12}>
                              <Grid2 item size={3.5}>
                                  <Typography sx={{fontSize:'14px', fontWeight:'500', color:'#83888E'}}>User Name</Typography>
                                  <Grid2 sx={{display:'flex', alignItems:'center', marginTop:'4px'}}>
                                      {selectedRow?.user_image ? <Avatar
                                          sx={{ borderColor: "#0065FF", border: 1, marginRight:'8px' }}
                                          alt="John Doe"
                                          src={selectedRow?.user_image}
                                      ></Avatar> : <Avatar sx={{ borderColor: "#0065FF", border: 1, marginRight:'8px' }} alt='name' src={altProfile}></Avatar>
                                      }
                                      <Typography>{selectedRow?.user_first_name + ' ' + selectedRow?.user_last_name}</Typography>
                                  </Grid2>
                              </Grid2>
                              <Grid2 item size={5}>
                                  <Typography sx={{fontSize:'14px', fontWeight:'500', color:'#83888E'}}>Email ID</Typography>
                                  <Grid2 sx={{display:'flex', alignItems:'center', marginTop:'4px'}}>
                                      <EmailIcon sx={{marginRight:'8px'}}/>
                                      <Typography>{selectedRow?.user_email}</Typography>
                                  </Grid2>
                              </Grid2>
                              <Grid2 item size={3.5}>
                                  <Typography sx={{fontSize:'14px', fontWeight:'500', color:'#83888E'}}>Phone Number</Typography>
                                  <Grid2 sx={{display:'flex', alignItems:'center', marginTop:'4px'}}>
                                      <PhoneIcon sx={{marginRight:'8px'}}/>
                                      <Typography>{selectedRow?.user_phone_number}</Typography>
                                  </Grid2>
                              </Grid2>
                              <Grid2 item size={3.5}>
                                  <Typography sx={{fontSize:'14px', fontWeight:'500', color:'#83888E'}}>Company Name</Typography>
                                  <Grid2 sx={{display:'flex', alignItems:'center', marginTop:'4px'}}>
                                      <Typography>{selectedRow?.user_company_name ? selectedRow?.user_company_name : '--'}</Typography>
                                  </Grid2>
                              </Grid2>
                              <Grid2 item size={5}>
                                  <Typography sx={{fontSize:'14px', fontWeight:'500', color:'#83888E'}}>No. of Seats</Typography>
                                  <Grid2 sx={{display:'flex', alignItems:'center', marginTop:'4px'}}>
                                      <img src={blackSeatIcon} alt="blackSeatIcon"/>
                                      <Typography sx={{marginLeft:'8px'}}>{selectedRow?.ticket_count}</Typography>
                                  </Grid2>
                              </Grid2>
                              <Grid2 item size={3}>
                                  <Typography sx={{fontSize:'14px', fontWeight:'500', color:'#83888E'}}>No. of Children</Typography>
                                  <Grid2 sx={{display:'flex', alignItems:'center', marginTop:'4px'}}>
                                      <Typography>{selectedRow?.no_of_childrens ? selectedRow?.no_of_childrens : '0'}</Typography>
                                  </Grid2>
                              </Grid2>
                              <Grid2 item size={3}>
                                  <Typography sx={{fontSize:'14px', fontWeight:'500', color:'#83888E'}}>Luggage</Typography>
                                  <Grid2 sx={{display:'flex', alignItems:'center', marginTop:'4px'}}>
                                      <img src={bagIcon} alt="bagIcon"/>
                                      <Typography sx={{marginLeft:'8px'}}>{selectedRow?.luggage_count}</Typography>
                                  </Grid2>
                              </Grid2>
                          </Grid2>

                          <hr/>
                          <Typography sx={{fontSize:'20px', fontWeight:'500', marginTop:'20px'}}>Driver Details</Typography>
                          <Grid2 container spacing={2} sx={{ marginTop:'16px', alignItems:'center', marginBottom:'16px'}} size={12}>
                              <Grid2 item size={3.5}>
                                  <Typography sx={{fontSize:'14px', fontWeight:'500', color:'#83888E'}}>Driver Name</Typography>
                                  <Grid2 sx={{display:'flex', alignItems:'center', marginTop:'4px'}}>
                                      {selectedRow?.driver_image ? <Avatar
                                          sx={{ borderColor: "#0065FF", border: 1, marginRight:'8px' }}
                                          alt="John Doe"
                                          src={selectedRow?.driver_image}
                                      ></Avatar> : <Avatar sx={{ borderColor: "#0065FF", border: 1, marginRight:'8px' }} alt='name' src={altProfile}></Avatar>
                                      }
                                      <Typography>{selectedRow?.driver_name}</Typography>
                                  </Grid2>
                              </Grid2>
                              <Grid2 item size={5}>
                                  <Typography sx={{fontSize:'14px', fontWeight:'500', color:'#83888E'}}>Email ID</Typography>
                                  <Grid2 sx={{display:'flex', alignItems:'center', marginTop:'4px'}}>
                                      <EmailIcon sx={{marginRight:'8px'}}/>
                                      <Typography>{selectedRow?.driver_email}</Typography>
                                  </Grid2>
                              </Grid2>
                              <Grid2 item size={3.5}>
                                  <Typography sx={{fontSize:'14px', fontWeight:'500', color:'#83888E'}}>Phone Number</Typography>
                                  <Grid2 sx={{display:'flex', alignItems:'center', marginTop:'4px'}}>
                                      <PhoneIcon sx={{marginRight:'8px'}}/>
                                      <Typography>{selectedRow?.driver_phone}</Typography>
                                  </Grid2>
                              </Grid2>
                          </Grid2>

                          <hr/>
                          <Typography sx={{fontSize:'20px', fontWeight:'500', marginTop:'20px'}}>Vehicle Details</Typography>
                          <Grid2 container spacing={2} sx={{ marginTop:'16px', alignItems:'center', marginBottom:'16px'}} size={12}>
                              <Grid2 item size={2.4}>
                                  <img src={blueCarIcon} alt="blueCarIcon"/>
                              </Grid2>
                              {/* <Grid2 item size={3.2}>
                                  <Typography sx={{fontSize:'14px', fontWeight:'500', color:'#83888E'}}>Vehicle Name</Typography>
                                  <Grid2 sx={{display:'flex', alignItems:'center', marginTop:'4px'}}>
                                      <Typography>Nissan</Typography>
                                  </Grid2>
                              </Grid2> */}
                              <Grid2 item size={3.2}>
                                  <Typography sx={{fontSize:'14px', fontWeight:'500', color:'#83888E'}}>Vehicle Category</Typography>
                                  <Typography>{selectedRow?.vehicle_category ? selectedRow?.vehicle_category : '--'}</Typography>
                              </Grid2>
                              <Grid2 item size={3.2}>
                                  <Typography sx={{fontSize:'14px', fontWeight:'500', color:'#83888E'}}>Vehicle Number</Typography>
                                  <Typography>{selectedRow?.vehicle_number ? selectedRow?.vehicle_number : '--'}</Typography>
                              </Grid2>
                          </Grid2>

                          <hr/>
                          <Typography sx={{fontSize:'20px', fontWeight:'500', marginTop:'12px'}}>Booking Details</Typography>
                          <Grid2 container spacing={2} sx={{ marginTop:'8px', alignItems:'center', marginBottom:'16px'}} size={12}>
                              <Grid2 item size={4}>
                                  <Typography sx={{fontSize:'14px', fontWeight:'500', color:'#83888E'}}>Booking Mode</Typography>
                                  <Grid2 sx={{display:'flex', alignItems:'center', marginTop:'4px'}}>
                                      <Typography sx={{ minWidth: '100px', color: selectedRow?.source==1 ? '#0C3B7C' : selectedRow?.source==2 ? '#AC8312' : selectedRow?.source==0 ? '#2B7FFF' : selectedRow?.source==-1 ? '#0065FF' : '#0065FF' }}>{selectedRow?.source==1 ? 'PIU' : selectedRow?.source==2 ? 'Transferz' : selectedRow?.source==0 ? 'Others' : selectedRow?.source==-1 ? 'Admin Panel' : 'Unknown'}</Typography>
                                      
                                  </Grid2>
                              </Grid2>
                              <Grid2 item size={4}>
                                  <Typography sx={{fontSize:'14px', fontWeight:'500', color:'#83888E'}}>Source ID</Typography>
                                  <Grid2 sx={{display:'flex', alignItems:'center', marginTop:'4px'}}>
                                      <Typography>{selectedRow?.source_id}</Typography>
                                      
                                  </Grid2>
                              </Grid2>
                              <Grid2 item size={4}>
                                  <Typography sx={{fontSize:'14px', fontWeight:'500', color:'#83888E'}}>Date & Time</Typography>
                                  <Grid2 sx={{display:'flex', alignItems:'center', marginTop:'4px'}}>
                                      <AccessTimeFilledIcon sx={{marginRight:'8px'}}/>
                                      <Typography>{selectedRow?.pickup_time ? 
                                        (() => {
                                        const pickupDate = new Date(selectedRow?.pickup_time);
                                        // Add the offset minutes to the date
                                        pickupDate.setMinutes(pickupDate.getMinutes() + utcOffset);
                                        return pickupDate.toLocaleString('en-GB', {
                                            day: '2-digit', 
                                            month: '2-digit', 
                                            year: 'numeric', 
                                            hour: '2-digit', 
                                            minute: '2-digit', 
                                            hour12: timeZoneFormat == '12' ? true : false,
                                            timeZone: 'UTC'
                                        }).replace(',', ' |');
                                        })() 
                                        : '--'
                                    }</Typography>
                                  </Grid2>
                              </Grid2>
                          </Grid2>
                          <Grid2 container spacing={2} sx={{ marginTop:'8px', alignItems:'center', marginBottom:'16px'}} size={12}>
                              <Grid2 item size={4}>
                                  <Typography sx={{fontSize:'14px', fontWeight:'500', color:'#83888E'}}>Parent Booking ID</Typography>
                                  <Grid2 sx={{display:'flex', alignItems:'center', marginTop:'4px'}}>
                                      <Typography>{selectedRow?.linked_booking_id}</Typography>
                                  </Grid2>
                              </Grid2>
                              <Grid2 item size={4}>
                                  <Typography sx={{fontSize:'14px', fontWeight:'500', color:'#83888E'}}>Journey Code</Typography>
                                  <Grid2 sx={{display:'flex', alignItems:'center', marginTop:'4px'}}>
                                      <Typography>{selectedRow?.journey_code ? selectedRow?.journey_code : '--'}</Typography>
                                  </Grid2>
                              </Grid2>
                          </Grid2>

                          <hr/>
                          <Typography sx={{fontSize:'20px', fontWeight:'500', marginTop:'12px'}}>Route Details</Typography>
                          
                          <Grid2 item>
                              <Grid2 sx={{display:'flex', alignItems:'center', marginTop:'3%'}}>
                                  <img height="22px" width="22px" src={pickupIcon}/>
                                  <Typography sx={{marginLeft:'1%'}}>{selectedRow?.pickup_address}</Typography>
                              </Grid2>
                          </Grid2>
                          <hr style={{border: 'none', borderTop: '1px dotted #E3E5E8'}}/>
                          <Grid2 item>
                              <Grid2>
                                  {selectedRow?.way_points?.map((item, index) => (
                                      <>
                                          <div key={index}>
                                              {(index!=0 && index!=selectedRow?.way_points.length-1) && 
                                                  (
                                                      <>
                                                      <Grid2 sx={{ marginTop:'2%',display:'flex', alignItems:'center'}}>
                                                          <span style={{
                                                              display: 'inline-block',
                                                              minWidth: 20,
                                                              minHeight: 20,
                                                              borderRadius: '50%',
                                                              background: '#2A313C',
                                                              color: '#fff',
                                                              fontWeight: 500,
                                                              textAlign: 'center',
                                                              lineHeight: '20px',
                                                              marginRight: 8
                                                          }}>{index}</span>
                                                          <Typography>{item.address}</Typography>
                                                          
                                                      </Grid2>
                                                      <hr style={{border: 'none', borderTop: '1px dotted #E3E5E8'}}/>
                                                      </>
                                                  )
                                              }
                                          </div>
                                      </>
                                  ))}
                                  {/* {selectedRow?.way_points==null && <Typography variant="subtitle2">--</Typography>} */}
                              </Grid2>
                          </Grid2>
                          <Grid2 item>
                              <Grid2 sx={{display:'flex', alignItems:'center', marginTop:'2%', marginBottom:'16px'}}>
                                  <img height="22px" width="22px" src={dropIcon}/>
                                  <Typography sx={{marginLeft:'1%'}}>{selectedRow?.drop_address}</Typography>
                              </Grid2>
                          </Grid2>


                          <Grid2 container spacing={2} sx={{ marginTop:'8px', alignItems:'center', marginBottom:'16px'}} size={12}>
                              <Grid2 item size={4}>
                                  <Typography sx={{fontSize:'14px', fontWeight:'500', color:'#83888E'}}>Distance (in km)</Typography>
                                  <Grid2 sx={{display:'flex', alignItems:'center', marginTop:'4px'}}>
                                      <Typography>{ischange_point_to_comma == '1'? selectedRow?.distance : formatNumberWithdecimal(selectedRow?.distance)}</Typography>
                                      
                                  </Grid2>
                              </Grid2>
                              <Grid2 item size={4}>
                                  <Typography sx={{fontSize:'14px', fontWeight:'500', color:'#83888E'}}>Duration (in minutes)</Typography>
                                  <Grid2 sx={{display:'flex', alignItems:'center', marginTop:'4px'}}>
                                      <Typography>{selectedRow?.duration}</Typography>
                                      
                                  </Grid2>
                              </Grid2>
                          </Grid2>


                          <hr/>
                          <Typography sx={{fontSize:'20px', fontWeight:'500', marginTop:'12px'}}>Flight Details</Typography>
                          <Grid2 container spacing={2} sx={{ marginTop:'8px', alignItems:'center', marginBottom:'16px'}} size={12}>
                              <Grid2 item size={6}>
                                  <Typography sx={{fontSize:'14px', fontWeight:'500', color:'#83888E'}}>Flight Number</Typography>
                                  <Grid2 sx={{display:'flex', alignItems:'center', marginTop:'4px'}}>
                                      <Typography>{selectedRow?.flight_number || '--'}</Typography>
                                  </Grid2>
                              </Grid2>
                          </Grid2>

                          <hr/>
                          <Typography sx={{fontSize:'20px', fontWeight:'500', marginTop:'12px'}}>Payment Details</Typography>
                          <Grid2 container spacing={2} sx={{ marginTop:'8px', alignItems:'center', marginBottom:'16px'}} size={12}>
                              <Grid2 item size={4}>
                                  <Typography sx={{fontSize:'14px', fontWeight:'500', color:'#83888E'}}>Fare</Typography>
                                  <Grid2 sx={{display:'flex', alignItems:'center', marginTop:'4px'}}>
                                      <Typography>€{ischange_point_to_comma == '1' ? selectedRow?.fare : formatNumberWithdecimal(selectedRow?.fare)|| '0'}</Typography>
                                  </Grid2>
                              </Grid2>
                              <Grid2 item size={4}>
                                  <Typography sx={{fontSize:'14px', fontWeight:'500', color:'#83888E'}}>Tax</Typography>
                                  <Grid2 sx={{display:'flex', alignItems:'center', marginTop:'4px'}}>
                                      <Typography>€{ischange_point_to_comma == '1' ? selectedRow?.tax : formatNumberWithdecimal(selectedRow?.tax) || '0'}</Typography>
                                  </Grid2>
                              </Grid2>
                              <Grid2 item size={4}>
                                  <Typography sx={{fontSize:'14px', fontWeight:'500', color:'#83888E'}}>Partner Price</Typography>
                                  <Typography>€{ischange_point_to_comma == '1' ? selectedRow?.partner_fare : formatNumberWithdecimal(selectedRow?.partner_fare) || '0'}</Typography>
                              </Grid2>
                          </Grid2>

                          <Grid2 container spacing={2} sx={{ marginTop:'8px', alignItems:'center', marginBottom:'16px'}} size={12}>
                              <Grid2 item size={4}>
                                  <Typography sx={{fontSize:'14px', fontWeight:'500', color:'#83888E'}}>Extras</Typography>
                                  <Grid2 sx={{display:'flex', alignItems:'center', marginTop:'4px'}}>
                                      <Typography>€{ischange_point_to_comma == '1' ? selectedRow?.extra_fare : formatNumberWithdecimal(selectedRow?.extra_fare) || '0'}</Typography>
                                  </Grid2>
                              </Grid2>
                              <Grid2 item size={4}>
                                  <Typography sx={{fontSize:'14px', fontWeight:'500', color:'#83888E'}}>Total Fare</Typography>
                                  <Grid2 sx={{display:'flex', alignItems:'center', marginTop:'4px'}}>
                                      <Typography>{'€ ' + (ischange_point_to_comma == 1 ? formatNumberWithComma(total) : total)}</Typography>
                                  </Grid2>
                              </Grid2>
                              <Grid2 item size={4}>
                                  <Typography sx={{fontSize:'14px', fontWeight:'500', color:'#83888E'}}>Payment Status</Typography>
                                  <Typography sx={{color:selectedRow?.payment_status==1 ? '#0DBA78' : '#AC8312'}}>{selectedRow?.payment_status==0 ? 'Pending' : selectedRow?.payment_status==1 ? 'Paid' : 'Unknown'}</Typography>
                              </Grid2>
                          </Grid2>

                          <Grid2 item>
                              <Typography sx={{fontSize:'14px', fontWeight:'500', color:'#83888E'}}>Payment Mode</Typography>
                              <Typography>{selectedRow?.payment_mode==1 ? 'Cash' : selectedRow?.payment_mode==2 ? 'Prepaid' : 'Unknown'}</Typography>
                          </Grid2>

                          <hr/>
                          <Typography sx={{fontSize:'20px', fontWeight:'500', marginTop:'12px'}}>Remarks</Typography>
                          <Grid2 container spacing={2} sx={{ marginTop:'8px', alignItems:'center', marginBottom:'16px'}} size={12}>
                              <Grid2 item size={6}>
                                  <Typography sx={{fontSize:'14px', fontWeight:'500', color:'#83888E'}}>Driver Remarks</Typography>
                                  <Grid2 sx={{display:'flex', alignItems:'center', marginTop:'4px'}}>
                                      <Typography>{selectedRow?.driver_remarks || '--'}</Typography>
                                  </Grid2>
                              </Grid2>
                              <Grid2 item size={6}>
                                  <Typography sx={{fontSize:'14px', fontWeight:'500', color:'#83888E'}}>Self Remarks</Typography>
                                  <Typography>{selectedRow?.self_remarks || '--'}</Typography>
                              </Grid2>
                          </Grid2>
                      </Grid2>

                  </Paper>
                  <div 
                      style={{
                          height: '10px',
                          backgroundColor: '#0065FF',
                          borderRadius: '0 0 12px 12px',
                          marginTop: '-1px',
                          position: 'relative',
                          zIndex: 1
                      }}
                  />
                  </Box>

              </div>
          </Box>
      </div>

      {openReassign && (
                          <div 
                          style={{position: 'fixed',top: 65, right:0, height: '100%',width: '38%',backgroundColor: '#f9f9f9',
                              boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)',transition: 'right 0.3s ease-in-out',
                              zIndex: 1000,overflowY: 'auto',padding: 20
                          }}>
                            <Box>
                              <div style={{ position: 'relative', padding: '40px 0' }}>
                                <IconButton aria-label="close" onClick={handleCloseassignModal}
                                    style={{
                                        position: 'absolute',top: '-15px',left: '1px',color: '#333',zIndex: 10}}>
                                    <CloseIcon style={{ fontSize: '32px', fontWeight: 'bold' }} />
                                </IconButton>
                                
                                <Paper sx={{borderRadius:'12px', padding:'16px'}}>
                                  <Typography style={{ marginBottom: '6px', marginTop: '6px', fontWeight: '500', fontSize:'24px' }}>
                                    Assign Driver
                                  </Typography>
                  
                                <Grid container spacing={2} sx={{marginTop:'3%', marginBottom:'2%'}}>
                                  <Grid item xs={12} sm={12}>
                                    <Label>Assign Driver</Label>
                                    <Select 
                                        sx={{
                                          marginTop:'2%',
                                          height: '48px', 
                                          borderRadius: '8px', 
                                          backgroundColor: '#FFFFFF',
                                          '& .MuiSelect-select': {
                                            display: 'flex',
                                            alignItems: 'center',
                                            paddingLeft: '12px'
                                          }
                                        }}
                                        value={assignDriver.driver_id} 
                                        fullWidth
                                        displayEmpty
                                        renderValue={(selected) => {
                                          return (
                                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                              <PersonIcon sx={{ color: '#666', mr: 1 }} />
                                              {selected ? driverData.find(driver => driver.driver_id === selected)?.driver_name : 'Select Driver'}
                                            </Box>
                                          );
                                        }}
                                        onChange={(e) => {
                                          const selectedDriver = driverData.find(driver => driver.driver_id === e.target.value);
                                          setAssignDriver(prevAssignDriver => ({
                                              ...prevAssignDriver,
                                              driver_id: selectedDriver.driver_id,
                                              // Only update vehicle_make_id from driver if no vehicle is already selected OR if the driver's vehicle is different
                                              // This prioritizes an explicitly chosen vehicle over the driver's default.
                                              // However, if the user picks a driver first, their default vehicle should populate.
                                              // A simpler approach: if a vehicle is already set, don't override it when changing driver.
                                              vehicle_make_id: prevAssignDriver.vehicle_make_id && prevAssignDriver.vehicle_make_id !== '' 
                                                               ? prevAssignDriver.vehicle_make_id 
                                                               : selectedDriver.vehicle_make_id || ''
                                          }));
                                        }}>
                                        <MenuItem value="" disabled>
                                          <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                            <PersonIcon sx={{ color: '#666', mr: 1 }} />
                                            Select Driver
                                          </Box>
                                        </MenuItem>
                                        {driverData && driverData.map((driver) => (
                                          <MenuItem key={driver.driver_id} value={driver.driver_id}>
                                            {driver.driver_name}
                                          </MenuItem>
                                        ))}
                                    </Select>
                                  </Grid>
                  
                                  <Grid item xs={12} sm={12}>
                                      <Label>Select Vehicle</Label>
                                      <Select 
                                        sx={{
                                          marginTop:'2%',
                                          height: '48px', 
                                          borderRadius: '8px', 
                                          backgroundColor: '#FFFFFF',
                                          '& .MuiSelect-select': {
                                            display: 'flex',
                                            alignItems: 'center',
                                            paddingLeft: '12px'
                                          }
                                        }}
                                        value={editVehicleMakeId || assignDriver.vehicle_make_id || ''} 
                                        fullWidth
                                        displayEmpty
                                        renderValue={(selected) => {
                                          const selectedVehicle = vehiclesMakeData?.find(vehicle => 
                                            vehicle.vehicle_make_id === selected || vehicle.id === selected);
                                          
                                          return (
                                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                              <img src={blueCarIcon} alt="Vehicle" style={{ marginRight: '8px', width: '30px', height: '30px' }} />
                                              {selected && selectedVehicle ? selectedVehicle.vehicle_number : 'Select Vehicle'}
                                            </Box>
                                          );
                                        }}
                                        onChange={(e) => {
                                            const selectedId = e.target.value;
                                            setEditVehicleMakeId(selectedId);
                                            
                                            // Find the selected vehicle and update assignDriver
                                            const selectedVehicle = vehiclesMakeData.find(vehicle => 
                                                vehicle.vehicle_make_id === selectedId || vehicle.id === selectedId);
                                            if (selectedVehicle) {
                                                // Update assignDriver with the new vehicle info
                                                setAssignDriver(prev => ({
                                                    ...prev,
                                                    vehicle_make_id: selectedVehicle.vehicle_make_id || selectedVehicle.id,
                                                    model_name: selectedVehicle.model_name || '', 
                                                    vehicle_number: selectedVehicle.vehicle_number || ''
                                                }));
                                            }
                                        }}>
                                        <MenuItem value="" disabled>
                                          <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                            <img src={blueCarIcon} alt="Vehicle" style={{ marginRight: '8px', width: '24px', height: '24px' }} />
                                            Select Vehicle
                                          </Box>
                                        </MenuItem>
                                        {vehiclesMakeData && vehiclesMakeData.map((vehicleMake) => (
                                          <MenuItem key={vehicleMake.id || vehicleMake.vehicle_make_id} 
                                            value={vehicleMake.id || vehicleMake.vehicle_make_id}>
                                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                              {vehicleMake.vehicle_number}
                                            </Box>
                                          </MenuItem>
                                        ))}
                                      </Select>
                                  </Grid>
                                </Grid>
                                
                                <div style={{ marginTop: '12%', display: 'flex', justifyContent: 'center', gap: '20px', marginBottom:'6%' }}>
                                  <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={handleSubmit}
                                    disabled={isSaving}
                                    sx={{
                                      width: '140px',
                                      height: '50px',
                                      textTransform: 'none',
                                      fontSize: '16px',
                                      backgroundColor: isSaving ? '#BDBDBD' : '#0065FF',
                                      color: 'white',
                                      '&:disabled': {
                                        backgroundColor: '#BDBDBD',
                                        color: 'white',
                                      }
                                    }}>
                                    {isSaving ? 'Saving...' : 'Done'}
                                  </Button>
                                  <Button
                                    variant="contained"
                                    onClick={handleCloseassignModal}
                                    sx={{
                                      width: '140px',
                                      height: '50px',
                                      textTransform: 'none',
                                      fontSize: '16px',
                                      backgroundColor: '#F0F0F0',
                                      color: '#B0B0B0',
                                    }}
                                  >
                                    Cancel
                                  </Button>
                                </div>
                  
                                </Paper>
                              </div>
                            </Box>
                          </div>
                        )}

      <Snackbar open={snackbar} autoHideDuration={2000} onClose={handleSnackbarClose} message={message}></Snackbar>
    </>
  );
};

export default BookingTable;
